import React from 'react';
import MasonryGallery from '../components/MasonryGallery';

const MasonryGalleryDemo: React.FC = () => {
  return (
    <div className="masonry-gallery-demo">
      <MasonryGallery />
    </div>
  );
};

export default MasonryGalleryDemo;
